<div class="welcome-container zd-gradient">
  <div class="welcome-content">
    <img width="100" src="./assets/audittrail.png" alt="Audit Trail" class="welcome-logo" />
    <h1 class="welcome-title">Audit Trail</h1>
    <p class="welcome-subtitle">
      Track changes in Raiser's Edge
    </p>
    <button mat-raised-button class="welcome-login-btn zd-button-gradient" routerLink="/login">
      Sign In
    </button>
    @if (isLogout) {
    <div class="logout-message">{{ logoutText }}</div>
    }
  </div>
  <div class="welcome-footer">
    <img src="./assets/zeidman_logo.jpg" alt="Zeidman Development" class="welcome-footer-logo" />
  </div>
</div>